exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title-module__title___Np9Hz{display:flex;height:100%;flex-direction:column;justify-content:flex-start}.Title-module__title___Np9Hz h2{font-weight:400;font-size:26px;text-transform:capitalize;line-height:1.1}", ""]);

// exports
exports.locals = {
	"title": "Title-module__title___Np9Hz"
};